import React, { useState } from "react";
import { Button, Col, Row, Typography, Breadcrumb } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";

import { translate } from "../../../locale";
import NotificationsTable from "../../../components/Tables/NotificationsTable";
import SendNotification from "../../../components/Modals/SendNotification";

const { Title } = Typography;

const Notifications = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [reloadTable, setReloadTable] = useState(null);
  const { username } = useParams();

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleModalComplete = () => {
    // update user list
    setModalVisible(false);
    setReloadTable((v) => v + 1);
  };

  const handleSendInvittion = () => {
    setModalVisible(true);
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Notificaciones")}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Notificaciones")}
          </Title>
        </Col>

        <Col className="gutter-row" span="12">
          <div className="text-start">
            <Button
              type="primary"
              className="bg-custom_primary border-custom_primary"
              onClick={handleSendInvittion}
            >
              {translate("Enviar notificación")}
            </Button>
            <SendNotification
              patient={username}
              visible={modalVisible}
              onCancel={handleModalCancel}
              onComplete={handleModalComplete}
            />
          </div>
        </Col>

        <Col span="24" className="mt-6">
          <NotificationsTable reload={reloadTable} />
        </Col>
      </Row>
    </div>
  );
};

export default Notifications;
